//import { capitalize as upper} from 'lodash';

import capitalize from 'react-bootstrap/lib/utils/capitalize';

const capitalise = (value) => {
  if (!value) {
    return value;
  }
  const tokens = value.split(' ').map((val) => {
    return capitalize(val);
  });
  return tokens.join(' ');
};

export default capitalise;
